const appSyncConfig = {
  aws_appsync_graphqlEndpoint: process.env.VUE_APP_GRAPHQL_ENDPOINT,
  aws_appsync_region: process.env.VUE_APP_APPSYNC_REGION,
  aws_appsync_authenticationType: 'AWS_LAMBDA',
  aws_appsync_apiKey: 'da2-tskosdktdbesbhtjib652uh53u',
};

export default appSyncConfig;
